import { useState } from 'react';
import { Button, Modal, Stack, Text, Group } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useNotifications } from '../useNotifications';
import logger from '@ayocore/platform/common/helpers/logger';

/**
 * DeleteAllModal - Modal component for confirming delete all action
 */
interface DeleteAllModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function DeleteAllModal({ opened, onClose, onConfirm }: DeleteAllModalProps) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // Ошибка уже обработана в NotificationController
      logger.error('Failed to delete all notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title='Удалить все уведомления' size='sm' centered>
      <Stack gap='md'>
        <Text>Вы уверены, что хотите удалить все уведомления? Это действие нельзя отменить.</Text>
        <Group justify='flex-end' gap='sm'>
          <Button variant='light' onClick={onClose} color='gray' size='xs' disabled={loading}>
            Отмена
          </Button>
          <Button variant='filled' onClick={handleConfirm} color='red' size='xs' loading={loading}>
            Удалить всё
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

/**
 * DeleteAllButton - Compact button to delete all notifications
 */
export function DeleteAllButton() {
  const { notifications, deleteAllNotifications } = useNotifications();
  const [opened, setOpened] = useState(false);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        size='xs'
        variant='light'
        color='red'
        leftSection={<IconTrash size={14} />}
        onClick={() => setOpened(true)}
      >
        Удалить всё
      </Button>

      <DeleteAllModal
        opened={opened}
        onClose={() => setOpened(false)}
        onConfirm={deleteAllNotifications}
      />
    </>
  );
}
